'use es6';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Map as ImmutableMap } from 'immutable';
import PortalIdParser from 'PortalIdParser';
import UIEditorPage from 'UIComponents/page/UIEditorPage';
import PracticalExerciseToolbar from '../components/PracticalExerciseToolbar';
import { getContentById } from '../../../selectors/contentSelectors';
import { getPracticalExerciseLink } from '../../../utils/ContentUtils';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { getLessonById } from '../../../actions/LessonActions';
import { fetchTrackByIdIfNeeded } from '../../../actions/TrackActions';
import { getSelectedLanguageFiltersFromRoute } from '../../../selectors/routeSelectors';
import { useLocation } from 'react-router-dom';
import { getNextContentUrl } from '../../../selectors/trackSelectors';
import { getNextLessonContentUrl } from '../../../selectors/lessonSelectors';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledEditorPage = styled(UIEditorPage).withConfig({
  displayName: "PracticalExerciseFrame__StyledEditorPage",
  componentId: "sc-1lej3sm-0"
})(["position:absolute;top:0;bottom:0;left:0;right:0;z-index:5;"]);
const FullscreenIframe = styled.iframe.withConfig({
  displayName: "PracticalExerciseFrame__FullscreenIframe",
  componentId: "sc-1lej3sm-1"
})(["width:100%;height:100%;border:0;"]);
const PracticalExerciseFrame = ({
  match: {
    params: {
      trackId,
      lessonId,
      contentId
    }
  }
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const language = getSelectedLanguageFiltersFromRoute({}, {
    location
  }).first();
  const practicalExercise = useSelector(state => getContentById(state, contentId) || ImmutableMap());
  const validTrackId = trackId && !isNaN(trackId);
  const nextContentUrl = useSelector(state => validTrackId ? getNextContentUrl(state, {
    contentId,
    lessonId,
    trackId
  }) : getNextLessonContentUrl(state, {
    contentId,
    lessonId
  }));
  useEffect(() => {
    const hideZorse = document.createElement('style');
    hideZorse.innerHTML = `#isc-zorse-widget, #chat-widget {
      display:none; }`;
    document.getElementsByTagName('head')[0].appendChild(hideZorse);
    if (validTrackId) {
      dispatch(fetchTrackByIdIfNeeded(trackId, language));
    } else {
      dispatch(getLessonById(lessonId, language));
    }
    return function cleanup() {
      hideZorse.remove();
    };
  }, [dispatch, lessonId, language, trackId, validTrackId]);
  const description = practicalExercise.get('description');
  const exerciseLanguage = practicalExercise.get('language');
  const isGraded = practicalExercise.get('graded');
  const isManuallyApproved = practicalExercise.get('manuallyApproved');
  const name = practicalExercise.get('name');
  const parentTo = validTrackId ? `/tracks/${trackId}/${lessonId}/${contentId}` : `/lessons/${lessonId}/${contentId}`;
  return /*#__PURE__*/_jsx(StyledEditorPage, {
    hasScrolling: false,
    headerComponent: /*#__PURE__*/_jsx(PracticalExerciseToolbar, {
      contentId: contentId,
      description: description,
      exerciseLanguage: exerciseLanguage,
      isGraded: isGraded,
      isManuallyApproved: isManuallyApproved,
      language: language,
      lessonId: lessonId,
      name: name,
      nextContentUrl: nextContentUrl,
      parentTo: parentTo,
      trackId: trackId
    }),
    mainSectionFlush: true,
    use: "dark",
    children: practicalExercise ? /*#__PURE__*/_jsx(NavMarker, {
      name: "PRACTICAL_EXERCISE_LOADED",
      children: /*#__PURE__*/_jsx(FullscreenIframe, {
        src: getPracticalExerciseLink(practicalExercise, PortalIdParser.getPortalIdFromPath(), document.location.href),
        title: name
      })
    }) : /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true,
      minHeight: 200
    })
  });
};
export default PracticalExerciseFrame;